<template>
  <!-- 数字展厅 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="96px">
        <el-row type="flex" :gutter="20">

          <el-col :span="6">
            <el-form-item label="日期：" prop="appointDate">
              <el-date-picker v-model="form.appointDate" value-format="yyyy-MM-dd" placeholder="请选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="机构类型：" prop="orgType">
              <el-select v-model="form.orgType" placeholder="请选择机构类型">
                <el-option v-for="item in orgList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="团队类型：" prop="teamType">
              <el-select v-model="form.teamType" placeholder="请选择团队类型">
                <el-option v-for="item in teamList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="机构名称：" prop="orgName">
              <el-input v-model="form.orgName" placeholder="请输入机构名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="负责人姓名：" prop="headName">
              <el-input v-model="form.headName" placeholder="请输入团队负责人姓名"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="联系方式：" prop="headPhone">
              <el-input v-model="form.headPhone" placeholder="请输入团队负责人联系方式"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="6">
            <el-form-item label="证件类型：">
              <el-select v-model="form.type" placeholder="请选择证件类型">
                <el-option v-for="item in cardList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <el-col :span="6">
            <el-form-item label="证件号码：" prop="headIdentificationNumber">
              <el-input v-model="form.headIdentificationNumber" placeholder="请输入团队负责人证件号码 "></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="审批状态：" prop="approveStatus">
              <el-select v-model="form.approveStatus" placeholder="请选择审批状态">
                <el-option v-for="item in approveStatus" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="订单状态：" prop="orderStatus">
              <el-select v-model="form.orderStatus" placeholder="请选择订单状态">
                <el-option v-for="item in orderList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="渠道：" prop="platform">
              <el-select v-model="form.platform" placeholder="请选择渠道">
                <el-option v-for="item in platformList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <div class="tr">
              <el-button type="primary" @click="getTableList">查询</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
            </div>
          </el-col>

        </el-row>
      </el-form>

      <!-- <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div> -->
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">

      <div class="button">
        <el-row type="flex">
          <el-popover placement="bottom" width="150" trigger="click">
            <el-checkbox-group @change="handleCheck" v-model="checkList">
              <el-checkbox :label="item.propName" v-for="(item, i) in checkLabels" :key="i" style="display: block;">{{
                item.label }}</el-checkbox>
            </el-checkbox-group>
            <span class="icon-wrapper" slot="reference">
              <svg-icon icon-class="shaixuan" class-name="icon-menu" />
            </span>
          </el-popover>

          <el-popover class="pop-wrapper" placement="bottom" width="150" trigger="click">
            <span class="icon-wrapper" slot="reference">
              <svg-icon icon-class="export" class-name="icon-menu" />
            </span>
          </el-popover>

          <span class="icon-wrapper">
            <svg-icon icon-class="print" class-name="icon-menu" />
          </span>

        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" style="width: 100%" v-loading="listLoading" :row-key="(row) => { return row.id }" stripe :data="tableData">
          <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column>
          <template v-for="item in checkLabels">
            <el-table-column v-if="item.show" :prop="item.propName" :label="item.label" :key="item.label" show-overflow-tooltip>

              <template slot-scope="scope">
                <span v-if="scope.column.property === 'times'">
                  <el-tooltip :content="`${scope.row.startTime } ~ ${ scope.row.endTime }`" placement="top-start">
                    <div>
                      {{ scope.row.startTime }} ~ {{ scope.row.endTime }}
                    </div>
                  </el-tooltip>
                </span>

                <span v-else>
                  <el-tooltip :content="scope.row[scope.column.property]" placement="top-start">
                    <div>{{ scope.row[scope.column.property]}}</div>
                  </el-tooltip>
                  <!-- {{ scope.row[scope.column.property] }}   -->
                </span>
              </template>

            </el-table-column>
          </template>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" width="250">
            <template slot-scope="scope">
              <a class="m-btn mr-10 m-danger" @click="handleView(scope.row)">查看</a>
              <a class="m-btn mr-10" @click="handleAppoint(scope.row)">核销</a>

              <a class="m-btn mr-10" v-if="scope.row.showNotice" @click="handleNotice(scope.row)">通知</a>
              <a class="m-btn mr-10" v-if="scope.row.showApprove" @click="handleEdit(scope.row)">审核</a>
              <a class="m-btn mr-10" @click="guide(scope.row)">游客信息</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialog-team-detail ref="dialogTicketSetting" @refresh="getData"></dialog-team-detail>
    <dialog-approve ref="dialogApprove" @refresh="getData"></dialog-approve>

  </div>
</template>

<script>
import DialogApprove from '../dialogs/dialog-approve.vue'
import dialogTeamDetail from '../dialogs/dialog-team-detail.vue'

export default {
  data() {
    return {
      form: {
        headName: '',
        headPhone: '',
        headIdentificationNumber: '',
        orgName: '',
        approveStatus: '',
        orderStatus: '',
        platform: '',
        appointDate: '',
        teamType: '',
        orgType: ''
      },
      cardList: [
        { value: '1', label: '身份证' },
        { value: '2', label: '护照' },
        { value: '3', label: '港澳台通行证' },
        { value: '4', label: '外国人永居证' }
      ],
      orderList: [
        { value: '0', label: '已取消' },
        { value: '1', label: '待参观' },
        { value: '2', label: '已入馆' },
        { value: '3', label: '已过期' },
        { value: '4', label: '待审核' },
        { value: '5', label: '已驳回' }
      ],
      approveStatus: [
        { value: '0', label: '待审批' },
        { value: '1', label: '已通过' },
        { value: '2', label: '已拒绝' }
      ],
      // checkLabels: [{ label: '机构类型', propName: 'name' }, { label: '机构名称', propName: 'date' }, { label: '负责人姓名', propName: '' }, { label: '负责人联系方式', propName: '' }, { label: '证件类型', propName: '' }, { label: '证件号码', propName: '' }, { label: '参观日期', propName: '' }, { label: '参观时段', propName: '' }, { label: '游客人数', propName: '' }, { label: '订单状态', propName: '' }, { label: '审批状态', propName: '' }, { label: '是否通知', propName: '' }],
      checkLabels: [
        { label: '机构类型', show: true, propName: 'orgType' },
        { label: '机构名称', show: true, propName: 'orgName' },
        { label: '参观日期', show: true, propName: 'appointDate' },
        { label: '参观时段', show: true, propName: 'times' },
        { label: '游客人数', show: true, propName: 'peopleNumber' },
        { label: '订单状态', show: true, propName: 'orderStatus' },
        { label: '审批状态', show: true, propName: 'approveStatus' },
        { label: '是否通知', show: true, propName: 'noticeStatus' }
      ],
      platformList: [
        { value: '1', label: '支付宝' },
        { value: '2', label: '微信' }
      ],

      orgList: [
        { value: '1', label: '企业及旅行社' },
        { value: '2', label: '机关事业单位及学校' }
      ],
      teamList: [
        { value: '1', label: '参观' },
        { value: '2', label: '写生' }
      ],
      checkList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      chooseRowIds: ''
    }
  },
  components: { dialogTeamDetail, DialogApprove },
  methods: {
    // 项目列表
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.appointSetting
        .getAppointTeamOrderList({
          ...this.form,
          // orgId: this.$route.query.orgId,
          ...this.listQuery
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleAppoint(obj) {
      let self = this
      this.$common
        .confirm1('确认要操作该数据?')
        .then(() => {
          self.$api.appointSetting
            .finishTeamAppoint({ id: obj.id })
            .then((res) => {
              if (res.code == 200) {
                self.$message.success('操作成功')
                self.getData()
              } else {
                self.$message.error(res.message || '系统异常')
              }
            })
        })
        .catch(() => {})
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach((item) => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    setHead() {
      this.checkLabels.map((item) => {
        this.checkList.push(item.propName)
      })
    },

    // 动态修改表头
    handleCheck(key) {
      for (let i = 0; i < this.checkLabels.length; i++) {
        if (this.checkList.includes(this.checkLabels[i].propName)) {
          this.checkLabels[i].show = true
        } else {
          this.checkLabels[i].show = false
        }
      }
      console.log(this.checkList)
    },

    // 重置查询
    resetForm() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleEdit(obj) {
      this.$refs['dialogApprove'].init(obj.id)
      // this.$common.confirm1('确认要操作该数据?').then(() => {
      //   this.$api.appointSetting.approveTeamAppoint({ id: obj.id, approveStatus: "1" }).then(res => {
      //     if (res.code == 200) {
      //       this.$message.success(res.message || '操作成功')
      //       this.getData()
      //     } else {
      //       this.$message.error(res.message || '系统异常')
      //     }
      //   })
      // })
      //   .catch(() => { })
    },

    handleNotice(obj) {
      this.$common
        .confirm1('确认要操作该数据?')
        .then(() => {
          this.$api.appointSetting
            .noticeTeamAppoint({ id: obj.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(res.message || '操作成功')
                this.getData()
              } else {
                this.$message.error(res.message || '系统异常')
              }
            })
        })
        .catch(() => {
          console.log(111)
        })
    },

    handleView(obj) {
      this.$refs.dialogTicketSetting.init(obj.id)
    },

    // 删除
    handleDelete(obj) {
      this.$common
        .confirm1('是否确认删除?')
        .then(function () {
          // return delCollection(obj.id)
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('删除成功')
            this.getData()
          } else {
            this.$message.error(res.msg || '系统异常')
          }
        })
        .catch(() => {})
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    guide(obj) {
      this.$router.push({
        path: '/reservation/order-team/tourist-info',
        query: { orderId: obj.id }
      })
    }
  },

  beforeUpdate() {
    this.$nextTick(() => {
      //在数据加载完，重新渲染表格
      this.$refs['multipleTable'].doLayout()
    })
  },

  created() {
    this.setHead()
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  .com-list-header {
    padding-right: 30px;

    .el-row--flex {
      flex-wrap: wrap;
    }
  }

  .com-list-content {
    .el-row--flex {
      justify-content: end;
    }
  }

  .icon-wrapper {
    display: flex;
    width: fit-content;
    padding: 6px;
    margin-left: 20px;
    border: 1px solid #ccc;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
      border: 1px solid #999;
      transition: 0.5s all;
    }

    .icon-menu {
      font-size: 20px;
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 20px;

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;

      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .avatar {
          width: 100%;
          height: 120px;
          object-fit: contain;
        }

        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }

      .tip-img {
        left: 0;
      }
    }
  }
}
</style>